import { render, staticRenderFns } from "./DynamicContentSlot.vue?vue&type=template&id=46bca2e8&scoped=true&"
import script from "./DynamicContentSlot.vue?vue&type=script&lang=js&"
export * from "./DynamicContentSlot.vue?vue&type=script&lang=js&"
import style0 from "./DynamicContentSlot.vue?vue&type=style&index=0&id=46bca2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bca2e8",
  null
  
)

export default component.exports